import * as components from './components'

export default [
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/assessment',
    component: components.AssessmentDetail,
    name: 'assessmentDetail',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/assessment/:sessionId',
    component: components.AssessmentLearn,
    name: 'assessmentLearn',
    props: true
  },
  {
    path: '/course/:uuid/learn/:entityType/:entityUuid/resource',
    component: components.ResourceLearn,
    name: 'resourceLearn',
    props: true
  },
  {
    path: '/course/:uuid/report/:entityUuid/attempt/:activityId/assessment/:sessionId',
    component: components.AssessmentReport,
    name: 'assessmentReport',
    props: true
  },
  {
    path: '/course/:uuid/rate/:entityType/:entityUuid/resource',
    component: components.ResourceRate,
    name: 'resourceRate',
    props: true
  },
  {
    path: '/course/scorm/done',
    component: components.ScormDone,
    name: 'scormDone',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/assessment/routes.js